import { render, staticRenderFns } from "./PowerPointRequestAccess.vue?vue&type=template&id=151446b2&scoped=true"
import script from "./PowerPointRequestAccess.vue?vue&type=script&lang=js"
export * from "./PowerPointRequestAccess.vue?vue&type=script&lang=js"
import style0 from "./PowerPointRequestAccess.vue?vue&type=style&index=0&id=151446b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151446b2",
  null
  
)

export default component.exports